//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Chart from "chart.js";
import axios from "axios";

export default {
  name: "device-report",
  props: ["device"],

  data() {
    return {
      chart: null,
      chartElement: null,
      uptimeAverage: null,
      uptimePerDayInPercent: [],
      offlineDevices: null,
      cX: null,
      cY: null,
      emptyChart: false,
    };
  },

  created() {
    axios
      .get(this.$store.getters.getApi + "devices/status-report/", {
        params: { identifier: this.device.identifier, days: 7 },
      })
      .then((response) => {
        this.uptimePerDayInPercent = response.data.uptimePerDayInPercent;
        this.uptimeAverage = response.data.averageUptimeInPercent;
        
        // set this always to 100 to ensure chart is never in negative area
        this.uptimePerDayInPercent[8] = 100;

        this.chartElement = document.getElementById("deviceReport");

        const today = new Date();
        let dayArrray = [];
        for (let i = 0; i < 7; i++) {
          let previousDate = new Date();
          previousDate.setDate(today.getDate() - (i+1));

          dayArrray.splice(
            0,
            0,
            String(previousDate.getDate()).padStart(2, "0") +
              "." +
              String(previousDate.getMonth() + 1).padStart(2, "0")
          );
        }

        const data = {
          labels: dayArrray,
          datasets: [
            {
              data: this.uptimePerDayInPercent,
              borderWidth: 0,
              fill: true,
              backgroundColor: "#3b4045",
            },
          ],
        };

        this.chart = new Chart(this.chartElement, {
          type: "bar",
          data: data,

          options: {
            responsive: true,
            segmentShowStroke: false,
            height: "100%",
            maintainAspectRatio: false,
            tooltips: {
              callbacks: {
                label: (ttItem, items) =>
                  `${
                    items.datasets[ttItem.datasetIndex].data[ttItem.index]
                  }%`,
              },
            },
            legend: {
              display: false,
            },
            scales: {
              y: {
                beginAtZero: true,
                min: 0,
                max: 100,
                ticks: {
                  stepSize: 20,
                },
              },
            },
            elements: {},

            plugins: {},
          },
        });
      });
  },
  methods: {
    // following method is REQUIRED
    // (don't change its name --> "show")
    show() {
      this.$refs.dialog.show();
    },

    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide() {
      this.$refs.dialog.hide();
    },

    onDialogHide() {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit("hide");
    },

    onOKClick() {
      // on OK, it is REQUIRED to
      // emit "ok" event (with optional payload)
      // before hiding the QDialog
      this.$emit("ok");
      // or with payload: this.$emit('ok', { ... })

      // then hiding dialog
      this.hide();
    },

    onCancelClick() {
      // we just need to hide dialog
      this.hide();
    },
  },
};
